import request, { requestHelper } from '@/api'
import Upload, { fileImport } from '@/components/Upload/ImageUpload'
import {
  areaFindListByCompanyCodeDetail,
  exportBuildingInfoList,
  findBuildingInfoDtlPage,
} from '@/services/customerServices'
import { fileDownload } from '@/utils/download'
import { Button, message } from 'antd'
import {useCallback, useEffect, useRef, useState} from 'react'
import {SActionBtn, SDrawer, SLowcodeList, STableActions, SIDRender, SDrawerOrModal} from 'shj-components'
import {baseURL, getAuth, getUser} from 'shj-utils'
import AddOrEdit from './addOrEdit'
import config from './config'
import Detail from './detail'
import { getXTransferInsideTenantId, fileConfirm } from '@/utils/common'
import UrlConfig from "@/api/UrlConfigs.ts";
import {authDict} from "shj-utils/dist/esm/utils";
import {httpOrgList} from "@/services/homeService.ts";

const buildingList = (props: any) => {
  const listRef = useRef<any>()
  const userInfo = getUser()
  const [visibleDrawer, setVisibleDrawer] = useState<boolean>(false)
  const editRef = useRef<any>()
  const [id, setId] = useState<any>('')
  const [type, setType] = useState<any>('add')
  const [loading, setLoading] = useState<boolean>(false)

  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        // query.handlflag = true
        query.flag = true
        findBuildingInfoDtlPage(current, pageSize, query).then((resp: any) => {
          resolve(resp)
        })
      } catch (e) {
        reject({ success: false })
      }
    })
  }
  // 刷新列表
  const refreshList = () => {
    const {
      current: { reload },
    } = listRef
    reload()
  }

  useEffect(() => {
    onCompanyChange(userInfo.companyId)
  }, [userInfo.companyId]);

  const getStatusOptions = async() => {
    const companyList = await httpOrgList()
    return new Promise( (resolve, reject) => {
      resolve({
        companyList,
        enabledOptions: {1: '是', 0: '否'},
        statusOptions: {
          0: '非重点',
          1: '重点',
        },
      })
    })
  }

  const onCompanyChange = (v) => {
    if(v){
      areaFindListByCompanyCodeDetail({orgId: v, handleFlag: true}).then(res => {
        listRef.current?.updateSearchData('buildingId', res)
      })
    } else {
      listRef.current?.updateSearchData('buildingId', [])
    }
  }

  const onAdd = useCallback(() => {
    setType('add')
    setId('0')
    setVisibleDrawer(true)
  }, [])
  const onView = (record: any) => {
    setType('view')
    setId(`${record.id}`)
    console.log(record.id, 'view')
    setVisibleDrawer(true)
  }
  const onEdit = (record: any) => {
    setType('edit')
    setId(`${record.id}`)
    setVisibleDrawer(true)
  }

  // 导出
  const onExport = useCallback((record: any) => {
    const searchData_ = listRef.current.getSearch().getFieldsValue()
    message.loading({ content: '导出中' })
    exportBuildingInfoList(searchData_)
      .then((res: any) => {
        if (res.status && res.status === 200) {
          message.destroy()
          fileConfirm()
        } else {
          message.error('下载失败')
          message.destroy()
        }
      })
      .catch(() => {
        message.destroy()
      })
  }, [])

  // 下载批量模板
  const onExportTemplate = useCallback((record: any) => {
    fileDownload(UrlConfig.PlusCrmWeb.BuildingInfoExportBuildingInfoTemplate)
  }, [])

  // 导入
  const onImport = (upload: any) => {
    return fileImport(request, '/plus-crm-web/buildingInfo/importBuildingInfo', upload)
  }

  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd, onExport, onExportTemplate, onCompanyChange },
    auth: authDict,
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      clueIdRender(text: any, record: any) {
        return (
          <SIDRender id={text} onClick={() => onView(record)} copy={false}></SIDRender>
        //      auth={'DetailtBuildingButton'}
        )
      },
      actionTool(text: any, record: any) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)}>
              {/* auth="EditBuildingButton"*/}
              编辑
            </SActionBtn>
          </STableActions>
        )
      },
      emphasisFlag(text: any) {
        return <div>{text == 1 ? '重点' : text == 0 ? '非重点' : ''}</div>
      },
      financialAttrRender(text: any) {
        return <div>{text == 1 ? 'F' : text == 0 ? '非F' : ''}</div>
      },
      // 下载工艺模板
      buildingDownloadTemplate(text: any, record: any) {
        const Tenant = 'X-Transfer-Inside-Tenant-Id'
        return (
          <a
            href={
              baseURL +
              `/config-web/buildingInfo/exportBuildingInfoTemplate?Authorization=${requestHelper?.getToken?.()}&${Tenant}=${getXTransferInsideTenantId?.()}`
            }
          >
            <Button

              onClick={() => {
                fileDownload(`/config-web/buildingInfo/exportBuildingInfoTemplate`)
              }}
            >
              下载批量添加模板
            </Button>
          </a>
        )
      },
      buildingInfoDownload(text: any, record: any) {
        return (
          <Button
            onClick={() => {
              fileDownload(
                `/config-web/buildingInfo/exportBuildingInfoList?Authorization=${requestHelper?.getToken?.()}`
              )
            }}
          >
            导出
          </Button>
        )
      },
      buildingInfoExcel(text: any, record: any) {
        return (
          <Upload listType="text" customRequest={onImport} itemRender={() => null}>
            <Button>批量导入</Button>
          </Upload>
        )
      },
    },
  }
  const closeDrawer = () => {
    setVisibleDrawer(false)
  }
  // 是否编辑
  const isEdit = () => {
    return id && id !== '0'
  }
  const onClose = () => {
    closeDrawer()
    listRef.current.reload()
  }
  const onSubmit = () => {
    if (id) {
      editRef.current?.onFinish()
    }
  }
  console.log(loading,'loading')

  return (
    <>
      <SLowcodeList config={{...config, searchInitialValues: { orgId: userInfo.companyId},}} ref={listRef} {...extension} />
      <SDrawerOrModal
        title={`${type !== 'view' ? (isEdit() ? '编辑' : '新增') : '详情'}`}
        onCancel={closeDrawer}
        open={visibleDrawer}
        onOk={onSubmit}
        resetText="取消"
        loading={loading}
        onResetFn={() => {
          onClose()
        }}
        width={1010}
        antdProps={{[type==='view' ? 'footer' : '']: null}}
      >
        {type !== 'view' ? (
          <AddOrEdit ref={editRef} loading={loading} visibleDrawer={visibleDrawer} id={id} onClose={onClose} setLoading={(loading) => setLoading(loading)}/>
        ) : (
            visibleDrawer && <Detail visibleDrawer={visibleDrawer} onClose={onClose} id={id}/>
        )}
      </SDrawerOrModal>
    </>
  )
}
export default buildingList
